// @ts-check

import ObjArrUtils from '@/utils/ObjArrUtils'
import _module from '@/store/base/module'

const module = {
  state: {
    appLoading: 0,
    appHeaderTitle: null,
    appHeaderColor: null,
    appDocumentTitle: process.env.APP_TITLE,
    appFullScreen: false
  },

  getters: {
    getAppLoading (state) {
      return state.appLoading
    },

    getAppHeaderTitle (state) {
      return state.appHeaderTitle
    },

    getAppHeaderColor (state) {
      return state.appHeaderColor
    },

    getAppDocumentTitle (state) {
      return state.appDocumentTitle
    },

    getAppFullScreen (state) {
      return state.appFullScreen
    }
  },

  mutations: {
    ADJUST_APP_LOADING (state, payload) {
      state.appLoading += payload
    },
    SET_APP_HEADER_TITLE (state, payload) {
      state.appHeaderTitle = payload
    },
    SET_APP_HEADER_COLOR (state, payload) {
      state.appHeaderColor = payload
    },
    SET_APP_DOCUMENT_TITLE (state, payload) {
      state.appDocumentTitle = payload
    },
    SET_APP_FULL_SCREEN (state, payload) {
      state.appFullScreen = payload
    }
  },

  actions: {
  }
}

export default ObjArrUtils.merge(_module, module)
